import Section from './Section';
import './Section.scss';

export default Section;
